import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconUnlockProps extends SVGProps<any> {}
export class SVGIconUnlock extends Component<SVGIconUnlockProps> {
  render() {
    const { width = 30, height = 25, color, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-lock"
        width={`${width}`}
        height={`${height}`}
        viewBox={`100 0 130 116.94`}
        {...rest}
      >
        <g transform="translate(-303.88 -476.85)">
          <path
            style={{ fill: '#364856' }}
            d="m481.17 556.76 0.0707-35.165h-36.735-36.735l-0.44306 35.165c0.0707 20.328 16.569 36.826 36.921 36.826s36.921-16.475 36.921-36.826z"
          />
          <path
            style={{ fill: 'white' }}
            d="m444.24 538.72c-4.0128 0-7.2476 3.2348-7.2476 7.2476 0 2.9243 1.7057 5.4595 4.196 6.6119v18.087h6.898v-18.532c2.0532-1.2839 3.4331-3.5668 3.4331-6.1668 0-4.0128-3.2666-7.2476-7.2794-7.2476z"
          />
          <path
            style={{ fill: '#364856' }}
            d="m466.18 518.98s-1.5413-42.129 31.854-42.129 31.34 42.129 31.34 42.129h-8.7341s-0.25689-31.854-22.606-32.624c-22.349-0.77066-21.065 32.624-21.065 32.624h-10.789z"
          />
        </g>
      </SVG>
    );
  }
}
